function bindLoginPopup() {
    var popup = document.getElementById('woocommerce-login-popup');

    if(popup) {
        var showBtns = document.querySelectorAll('.showlogin');
        var body = document.querySelector('.wp-singular');
        var loginForm = document.querySelector('.login-popup__form .login');

        showBtns.forEach(function (btn) {
            // Prevent double binding
            if (!btn.classList.contains('popup-bound')) {
                btn.classList.add('popup-bound');
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    popup.classList.add('is-active');
                    body.classList.add('overflow-hidden');
                    loginForm.classList.add('is-active');
                });
            }
        });

        popup.addEventListener('click', function (e) {
            if (e.target === popup) {
                popup.classList.remove('is-active');
            }
        });

        // Close on ESC key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
                popup.classList.remove('is-active');
                if (body) body.classList.remove('overflow-hidden');
                if (loginForm) loginForm.classList.remove('is-active');
            }
        });

    }
}

document.addEventListener('DOMContentLoaded', function () {
    bindLoginPopup();

    // Observe WooCommerce notifications
    var targetNode = document.body;
    var observer = new MutationObserver(function (mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1 && node.matches('.woocommerce-NoticeGroup, .woocommerce-error, .woocommerce-message')) {
                        setTimeout(bindLoginPopup, 300); // Delay to ensure DOM is updated
                    }
                });
            }
        }
    });

    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });
    
});